/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Col_TournamentInputs */



/**
* | output |
* | --- |
* | "Tournament" |
*
* @param {User_Detail_Col_TournamentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_col_tournament = /** @type {((inputs?: User_Detail_Col_TournamentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Col_TournamentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo")
	return /** @type {LocalizedString} */ ("Tournament")
});